import script from "./createRescheduleRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./createRescheduleRequest.vue?vue&type=script&setup=true&lang=js"

import "./createRescheduleRequest.vue?vue&type=style&index=0&id=56679222&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56679222"]])

export default __exports__